import * as Sentry from "@sentry/react";
import { QueryClientProvider } from "@tanstack/react-query";
import { PropsWithChildren } from "react";
import { QueryParamProvider } from "use-query-params";
import { ReactRouter6Adapter } from "use-query-params/adapters/react-router-6";

import { MaintenanceCheck } from "@/features/maintenance";
import { useNotificationsSubscription } from "@/features/notifications";
import { useTicketsSubscription } from "@/features/tickets";
import { queryClient } from "@/shared/api/query-client";
import { TooltipProvider } from "@/shared/ui/kit/tooltip";
import { WebSocketProvider } from "@/shared/websocket";

function ErrorFallback() {
  return (
    <div style={{ padding: "2rem", textAlign: "center" }}>
      <h1>Something went wrong</h1>
      <button onClick={() => window.location.reload()}>Reload</button>
    </div>
  );
}

function WebSocketSubscriptions() {
  useTicketsSubscription();
  useNotificationsSubscription();
  return null;
}

export function Providers({ children }: PropsWithChildren) {
  return (
    <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <QueryParamProvider adapter={ReactRouter6Adapter}>
            <WebSocketProvider>
              <WebSocketSubscriptions />
              <MaintenanceCheck>{children}</MaintenanceCheck>
            </WebSocketProvider>
          </QueryParamProvider>
        </TooltipProvider>
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  );
}
